
























import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({})
export default class BaseModal extends Vue {
  @Prop() public showModal?: boolean
}
